export default __webpack_public_path__ + "static/media/winpupsnd.f5e8499a.mp3";